import './image-input.scss'
import { useState } from 'react'
import MediaLibrary from '../MediaLibrary/MediaLibrary'

const ImageInput = ({ value, onChange, label = 'Image', type = 'general' }) => {
  const [mediaLibraryOpen, setMediaLibraryOpen] = useState(false)
  const { src, name } = value || {}

  function handleMediaLibrarySubmit(image) {
    setMediaLibraryOpen(false)
    onChange({
      src: image.url,
      name: image.name,
    })
  }

  function getName() {
    if (name) {
      return name
    }
    if (src) {
      return src?.split('/')?.slice(-1)?.pop()?.split('.')?.shift()
    }
  }

  return (
    <div className="image-input">
      <label>{label}</label>
      <div className="flex">
        <div className="w-[100px] h-[100px] bg-deep">
          {src && <img src={src} className="w-full h-full object-cover" />}
        </div>
        <div className="flex flex-col px-4 py-2">
          <div>{getName() || 'No Image Selected'}</div>
          <div className="flex-fill flex items-end">
            <button
              className="button small bg-blue-dark mt-4"
              onClick={() => setMediaLibraryOpen(true)}
            >
              Choose
            </button>
          </div>
        </div>
      </div>

      <MediaLibrary
        isOpen={mediaLibraryOpen}
        onCancel={() => setMediaLibraryOpen(false)}
        onSubmit={handleMediaLibrarySubmit}
        type={type}
      />
    </div>
  )
}

export default ImageInput
